import { useState } from 'react';
import { Badge } from './badges';
import { CheckIcon, CrossIcon } from '../common';
import { speakJa } from '../../../components/speech';
import type { ListeningChoiceFixture } from '../../../mock/practice';

/** UI nghe hiểu chạy trên fixture (DB có 0 bản ghi LISTENING_CHOICE) — xem src/mock/practice.ts. */
export function ListeningChoiceExercise({ data }: { data: ListeningChoiceFixture }) {
  const [played, setPlayed] = useState(false);
  const [picked, setPicked] = useState<number | null>(null);
  const isCorrect = picked === data.correctIndex;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Badge tone="warning">Dữ liệu mẫu</Badge>
        <Badge tone="info">Nghe hiểu</Badge>
      </div>
      <h2 style={{ fontSize: 19, fontWeight: 600, textAlign: 'center', color: 'var(--ink)', margin: 0 }}>{data.question}</h2>

      <div style={{ background: 'var(--surface-section)', borderRadius: 'var(--radius-card)', padding: 16, display: 'flex', alignItems: 'center', gap: 16 }}>
        <button
          aria-label="Nghe"
          onClick={() => {
            speakJa(data.transcriptJp);
            setPlayed(true);
          }}
          style={{
            width: 72,
            height: 72,
            flexShrink: 0,
            borderRadius: '50%',
            background: 'var(--cta-default)',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 'var(--shadow-card)',
          }}
        >
          <svg width={28} height={28} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 5 6 9H2v6h4l5 4z" />
            <path d="M15.5 8.5a5 5 0 0 1 0 7" />
            <path d="M19 5a9 9 0 0 1 0 14" />
          </svg>
        </button>
        <div style={{ flex: 1, height: 6, borderRadius: 999, background: 'var(--border-default)', overflow: 'hidden' }}>
          <div style={{ width: played ? '100%' : '0%', height: '100%', background: 'var(--cta-default)', borderRadius: 999, transition: 'width 0.3s ease' }} />
        </div>
      </div>

      {!played && <div style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>Nghe ít nhất 1 lần để trả lời</div>}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, opacity: played ? 1 : 0.4 }}>
        {data.options.map((opt, i) => {
          const isThisCorrect = i === data.correctIndex;
          let bg = 'var(--surface-page)';
          let border = 'var(--border-default)';
          if (picked !== null && isThisCorrect) {
            bg = 'rgba(46,139,87,0.12)';
            border = 'var(--success)';
          } else if (picked !== null && i === picked && !isCorrect) {
            bg = 'var(--error-bg)';
            border = 'var(--error)';
          }
          return (
            <button
              key={opt}
              onClick={() => {
                if (!played || picked !== null) return;
                setPicked(i);
              }}
              style={{
                border: `2px solid ${border}`,
                background: bg,
                borderRadius: 'var(--radius-card)',
                padding: 16,
                textAlign: 'left',
                cursor: played && picked === null ? 'pointer' : 'default',
                fontFamily: 'var(--font-vi)',
                fontSize: 16,
                fontWeight: 600,
                color: 'var(--ink)',
              }}
            >
              {opt}
            </button>
          );
        })}
      </div>

      {picked !== null && (
        <>
          <div
            style={{
              alignSelf: 'flex-start',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              background: isCorrect ? 'var(--success)' : 'var(--error)',
              color: '#fff',
              borderRadius: 999,
              padding: '8px 16px',
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            {isCorrect ? <CheckIcon /> : <CrossIcon />}
            {isCorrect ? 'Đúng rồi!' : 'Chưa đúng'}
          </div>
          <div style={{ background: 'var(--surface-section)', borderRadius: 'var(--radius-card)', padding: 16 }}>
            <div style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--text-secondary)', letterSpacing: 0.4 }}>TRANSCRIPT</div>
            <div style={{ fontFamily: 'var(--font-jp)', fontSize: 16, color: 'var(--ink)', marginTop: 4 }}>{data.transcriptJp}</div>
            <div style={{ fontSize: 14, color: 'var(--text-secondary)', marginTop: 2 }}>{data.transcriptVi}</div>
          </div>
        </>
      )}
    </div>
  );
}
